import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';


class Home extends Component {

    componentDidMount() {
        window.addEventListener("resize", this.updateDimentions)
    }

    componentWillUnmount() {
       window.removeEventListener("resize", this.updateDimentions);
    }

    updateDimentions = () => {
        this.props.reSize(window.innerWidth, window.innerHeight)
    }

    onClick (type,addorview) {
        this.props.goToPage(type.toLowerCase(),addorview)
    }

    tiles = [
        {addlabel:'New Idea', viewlabel :'View Ideas', type:'Idea'},
        {addlabel:'New Pain', viewlabel :'View Pains', type:'Pain'},
        {addlabel:'New Opportunity', viewlabel :'View Opportunities',type:'Opportunity'},
        {addlabel:'New Test',viewlabel :'View Tests', type:'Test'}
    ];

    renderTiles = () => {
        var tilesJSX = [];
        var colourClasses = ['home-tile-dg','home-tile-lg'];
        var type = '';
        for (var i = 0; i < this.tiles.length; i++){
            type = this.tiles[i].type;
            tilesJSX.push(
                <div key={i} className="home-tile-row">
                    <div className={"home-tile " + colourClasses[i % 2]} onClick={this.onClick.bind(this,type,'add')}>
                        <div className="home-tile-text">
                            {this.tiles[i].addlabel}
                        </div>
                    </div>
                    <div className={"home-tile " + colourClasses[(i+1) % 2]} onClick={this.onClick.bind(this,type,'view')}>
                        <div className="home-tile-text">
                            {this.tiles[i].viewlabel}
                        </div>
                    </div>
                </div>
            )
        }
        return tilesJSX;
    }

    renderHome = () => {

        var tileheight;
        if ((this.props.location.pathname === "/" && this.props.authenticated) || this.props.location.pathname !== "/") {
            tileheight = window.innerHeight - 130;
        } else {
            tileheight = window.innerHeight
        }
        if (!this.props.authenticated) {
            return (
                <div style={{ height: tileheight }} className="home">
                    <div style={{ height: tileheight/3.33 }}></div>
                    <div>
                        <div className="home-mntd-logo">mntd<span className="blue-dot">.</span></div>
                        <div style={{ height: tileheight/60 }}></div>
                        <div className="sub-title"> Engineering New Enterprises </div>
                        <div style={{ height: tileheight/30 }}></div>
                        <div className = "sign-in-row">
                            <div className="home-links">
                                <div className="home-link-container"><a href='/signin'>Sign In</a></div>
                                <div className="text-spacer"></div>
                                <div className="home-link-container"><a href='/signup'>Sign Up</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="home-menu">
                    <div style={{ height: tileheight }} className="home-tile-area">
                        {this.renderTiles()}
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {this.renderHome()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return { authenticated: state.app.authenticated,
            width: state.app.width,
            height: state.app.height};
}

export default connect(mapStateToProps, actions)(Home);



// WEBPACK FOOTER //
// ./src/pages/home.js